<template>
  <div class="item" @click="postTopicFun()">
    <div class="item_title"><div class="icon">{{index}}</div>{{postTopic.title}}</div>
    <div class="item_msg" v-html="postTopic.content"></div>
    <div class="item_bot"><div class="item_bot_name">すでに{{postTopic.pictureNum}}人が参加、{{postTopic.participantNum}}枚の写</div></div>
    <div class="item_img">
      <img :src="postTopic.cover" />
    </div>
  </div>
</template>

<script>
import { timeToStr } from '@/assets/js/util'
import * as json from '@/assets/js/json'
export default {
  props: {
    postTopic: {
      type: Object,
      default: () => {
        return {}
      }
    },
    index: {
      type: Number,
      default: () => {
        return 0
      }
    }
  },
  components: {
  },
  data () {
    return {

    }
  },
  created () {
  },
  methods: {
    postTopicFun(){
      this.$emit('updatePostTopicId',this.postTopic.id)
    }
  }
}
</script>

<style src="@/pages/index/find/index.css" scoped>
</style>